import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import { request } from '../../../_network/request'
import { serviceConfigsURLs } from '../../../_network/apiUrls'
import { checkAccessRequest } from '../../../_network/request'
import {
  setProgressStep,
  setOpenStackConfigs,
  setAdminUiConfigs,
  setCustomerUiConfigs,
  setBillingConfigs,
  setBillingConfigPermissions,
} from '../../../store/reducers/subscriptionAddSlice'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'
import { uiDomainInitial, uiCertificateInitial } from '../_common/userInterfaceConstants'
import { isWildcardMatch } from '../_helpers/rsaCertificates'
import { isBillingAvailable } from '../_helpers/billing'
import ConfigMenu from './ConfigMenu'
import ConfigOpenStack from './ConfigOpenStack'
import ConfigUserInterfaces from './ConfigUserInterfaces'
import ConfigBilling from './ConfigBilling'
import CustomDialog from '../../_common/CustomDialog'
import CustomBackdrop from '../../_common/CustomBackdrop'

const ConfigWrapper = (props) => {
  const {
    setStep,
    selectedServices,
    supportedServiceConfigs,
    supportedPaymentMethods,
    appCredentialSecret,
    setAppCredentialSecret,
    paymentMethodIds,
    setPaymentMethodIds,
  } = props
  const theme = useTheme()
  const dispatch = useDispatch()
  
  const openstack_configs = useSelector(state => state.subscriptionAdd.openstack_configs)
  const admin_ui_configs = useSelector(state => state.subscriptionAdd.admin_ui_configs)
  const customer_ui_configs = useSelector(state => state.subscriptionAdd.customer_ui_configs)  
  const billing_configs = useSelector(state => state.subscriptionAdd.billing_configs)
  const billing_permissions = useSelector(state => state.subscriptionAdd.billing_permissions)
  const subscription_package_name = useSelector(state => state.subscriptionAdd.subscription_package.name)
  const credentialsRequired = subscription_package_name !== 'openstackBackupAutomation'
  
  const [selectedTab, setSelectedTab] = useState(null)
  const [configMenu, setConfigMenu] = useState([])
  const [showOpenStackServices, setShowOpenStackServices] = useState(false)
  const [showAdminUI, setShowAdminUi] = useState(false)
  const [showCustomerUI, setShowCustomerUi] = useState(false)
  const [showBillingService, setShowBillingService] = useState(false)
  const [selectedBackendServices, setSelectedBackendServices] = useState([])
  const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  const [errors, setErrors] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  
  const [backendUserData, setBackendUserData] = useState([])
  const [backendIsIdentityProviderSelected, setBackendIsIdentityProviderSelected] = useState(false)

  const [adminUiDomain, setAdminUiDomain] = useState([{ ...uiDomainInitial }])
  const [adminUiCertificateGenerate, setAdminUiCertificateGenerate] = useState(true)
  const [adminUiCertficates, setAdminUiCertificates] = useState([{ ...uiCertificateInitial }])
  const [adminUiSiteKey, setAdminUiSiteKey] = useState('')
  const [adminUiSecretKey, setAdminUiSecretKey] = useState('')
  const [adminUiLogo, setAdminUiLogo] = useState(null)
  const [adminUiPrimaryColor, setAdminUiPrimaryColor] = useState(theme.palette.oriolesOrange)
  const [adminUiSecondaryColor, setAdminUiSecondaryColor] = useState(theme.palette.mayGreen)
  
  const [customerUiDomain, setCustomerUiDomain] = useState([{ ...uiDomainInitial }])
  const [customerUiCertificateGenerate, setCustomerUiCertificateGenerate] = useState(true)
  const [customerUiCertficates, setCustomerUiCertificates] = useState([{ ...uiCertificateInitial }])
  const [customerUiSiteKey, setCustomerUiSiteKey] = useState('')
  const [customerUiSecretKey, setCustomerUiSecretKey] = useState('')
  const [defaultOpenStackDomain, setDefaultOpenStackDomain] = useState('')
  const [defaultOpenStackUserRole, setDefaultOpenStackUserRole] = useState('')
  const [signUpEnabled, setSignUpEnabled] = useState(true)
  const [isUsername, setIsUsername] = useState(false)
  const [usernamePriority, setUsernamePriority] = useState(10)
  const [isPassword, setIsPassword] = useState(false)
  const [passwordPriority, setPasswordPriority] = useState(20)
  const [isConfirmPassword, setIsConfirmPassword] = useState(false)
  const [confirmPasswordPriority, setConfirmPasswordPriority] = useState(30)
  const [isEmail, setIsEmail] = useState(false)
  const [emailPriority, setEmailPriority] = useState(40)
  const [isTermsOfUse, setIsTermsOfUse] = useState(false)
  const [termsOfUseText, setTermsOfUseText] = useState('')
  const [termsOfUseFile, setTermsOfUseFile] = useState(null)
  const [termsOfUseUrlPrefix, setTermsOfUseUrlPrefix] = useState('https://')
  const [termsOfUseUrl, setTermsOfUseUrl] = useState('')
  const [termsOfUseType, setTermsOfUseType] = useState('string')
  const [isPrivacyPolicy, setIsPrivacyPolicy] = useState(false)
  const [privacyPolicyText, setPrivacyPolicyText] = useState('')
  const [privacyPolicyFile, setPrivacyPolicyFile] = useState(null)
  const [privacyPolicyUrlPrefix, setPrivacyPolicyUrlPrefix] = useState('https://')
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('')
  const [privacyPolicyType, setPrivacyPolicyType] = useState('string')
  const [customFields, setCustomFields] = useState([])
  const [customerUiLogo, setCustomerUiLogo] = useState(null)
  const [customerUiPrimaryColor, setCustomerUiPrimaryColor] = useState(theme.palette.brilliantAzure)
  const [customerUiSecondaryColor, setCustomerUiSecondaryColor] = useState(theme.palette.darkCyan)
  const [backgroundType, setBackgroundType] = useState('')
  const [colorType, setColorType] = useState('')
  const [backgroundColor, setBackgroundColor] = useState(theme.palette.darkCyan)
  const [gradientColor1, setGradientColor1] = useState(theme.palette.darkCyan)
  const [gradientColor2, setGradientColor2] = useState(theme.palette.darkCyan)
  const [backgroundImage, setBackgroundImage] = useState(null)
  const [headingText, setHeadingText] = useState('')
  const [promoText1, setPromoText1] = useState('')
  const [promoText2, setPromoText2] = useState('')
  const [promoText3, setPromoText3] = useState('')
  const [isContact, setIsContact] = useState(true)
  const [contactCompany, setContactCompany] = useState('')
  const [contactPhone, setContactPhone] = useState([''])
  const [contactEmail, setContactEmail] = useState([''])

  const [domainsWithCertififcates, setDomainsWithCertificates] = useState([])

  const [enableBillingService, setEnableBillingService] = useState(false)
  const [defaultAccountType, setDefaultAccountType] = useState('')
  const [postpaidInvoiceType, setPostpaidInvoiceType] = useState('')
  const [postpaidInvoicePayPeriod, setPostpaidInvoicePayPeriod] = useState('')
  const [allowPublicCalculator, setAllowPublicCalculator] = useState(true)
  const [currency, setCurrency] = useState('')
  const [enableVat, setEnableVat] = useState(true)
  const [pricesIncludeVat, setPricesIncludeVat] = useState(true)
  const [vatTax, setVatTax] = useState('')
  const [paymentMethods, setPaymentMethods] = useState([])
  const [billingServicesConfigurable, setBillingServicesConfigurable] = useState(false)
  const [billingPermissions, setBillingPermissions] = useState(null)
  
  const getConfigMenu = useCallback(() => {
    return [
      {
        label: defaultTexts.openStackServices,
        value: 'openstack_services',
      },
      {
        label: defaultTexts.userInterfaces,
        value: 'user_interfaces',
      },
      {
        label: defaultTexts.billingService,
        value: 'billing_service',
      },
    ]
  }, [])

  const nextButtonStyle = {
    fontWeight: '400',
    color: 'white',
    background: theme.palette.violetsAreBlue,
    fontSize: '18px',
    height: '44px',
    borderRadius: '22px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.violetsAreBlue, 0.8),
    },

    '&:disabled': {
      background: theme.palette.grayX11,
      color: 'white',
    },
  }

  const handleErrorDialogOpen = () => {
    setErrorDialogOpen(true)
  }

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false)
  }

  const checkBackendDomains = async () => {    
    let result = true
    let updated_backend_services = []

    for (let index = 0; index < backendUserData.length; index++) {
      const s = backendUserData[index]
      let new_access = ''

      if (s.access !== 'checked' && s.service_domain) {
        const url = s.service_domain
        const response = await checkAccessRequest(url)

        if (response && response.status_code && response.status_code < 400) {
          new_access = 'checked'
        } else {
          new_access = 'not_checked'
          result = false
        }

        updated_backend_services.push({ ...s, status: new_access })
      } else {
        updated_backend_services.push(s)
      }
    }
    
    return {
      result,
      backend_services: updated_backend_services,
    }
  }

  const verifyDomain = async ({ type, showLoading }) => {
    if (showLoading) {
      setIsLoading(true)
    }

    const domains = type === 'admin' ? adminUiDomain : customerUiDomain
    
    let result = true
    let updated_domains = []    

    for (let index = 0; index < domains.length; index++) {
      const d = domains[index]
      let new_status = ''

      if (!d.domain_name) {
        result = false
      }

      if (d.domain_name && d.status !== 'verified') {
        const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceDnsResolver

        const postData = {
          domain_name: d.domain_name,
          subdomain_prefix: d.subdomain_prefix,
          type,
        }

        const request_data = { url, method: 'POST', data: postData }    

        const response = await request(request_data)
        
        if (response && response.status_code < 400) {
          new_status = 'verified'
        } else {
          new_status = 'not verified'
          result = false

          if (response && response.error) {
            const error = JSON.parse(response.error)
            if (error && error.detail) {
              new_status = error.detail
            }
          }
        }
        //--------------------------------------------------------
        // new_status = 'verified'

        updated_domains.push({ ...d, status: new_status })
      } else {
        updated_domains.push(d)
      }
    }

    if (showLoading) {
      setIsLoading(false)
    }
    
    type === 'admin' ? setAdminUiDomain(updated_domains) : setCustomerUiDomain(updated_domains)
    
    return {
      result,
      domains: updated_domains,
    }
  }

  // ----------------------------------------------------------------------------------------------
  // Validate Backend -----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------

  const validateBackendForm = () => {
    let errors_list = []
    
    if (!backendIsIdentityProviderSelected) {
      errors_list.push({
        title: defaultTexts.identityProviderIsNotSelected,
      })
    }

    let duplicated_region_name = false
    
    for (let index = 0; index < backendUserData.length; index++) {
      const s = backendUserData[index]
      
      const same_region = backendUserData.filter(item => item.service === s.service && item.region_name === s.region_name)

      if (same_region.length > 1) {
        duplicated_region_name = true
      }

      const hasBilling = isBillingAvailable(s.service, supportedServiceConfigs)
      
      if (billingServicesConfigurable && s.enable_billing) {
        if (!s.service_domain) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.serviceDomain,
            field_key: s.service + '-' + s.region_name + '-service_domain',
          })
        }
  
        if (!s.api_version) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.apiVersion,
            field_key: s.service + '-' + s.region_name + '-api_version',
          })
        }
  
        if (s.service === 'identity_keystone' && !s.default_region) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.defaultRegion,
            field_key: s.service + '-' + s.region_name + '-default_region',
          })
        }
  
        if (s.service !== 'identity_keystone' && !s.region_name) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.regionName,
            field_key: s.service + '-' + s.region_name + '-region_name',
          })
        }
  
        if (s.service === 'identity_keystone' && !s.app_credential_id && credentialsRequired) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.appCredentialId,
            field_key: s.service + '-' + s.region_name + '-app_credential_id',
          })
        }
  
        if (s.service === 'identity_keystone' && !appCredentialSecret && credentialsRequired) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.appCredentialSecret,
            field_key: s.service + '-' + s.region_name + '-app_credential_secret',
          })
        }
      } else if (!billingServicesConfigurable) {
        if (!s.service_domain) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.serviceDomain,
            field_key: s.service + '-' + s.region_name + '-service_domain',
          })
        }
  
        if (!s.api_version) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.apiVersion,
            field_key: s.service + '-' + s.region_name + '-api_version',
          })
        }
  
        if (s.service === 'identity_keystone' && !s.default_region) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.defaultRegion,
            field_key: s.service + '-' + s.region_name + '-default_region',
          })
        }
  
        if (s.service !== 'identity_keystone' && !s.region_name) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.regionName,
            field_key: s.service + '-' + s.region_name + '-region_name',
          })
        }
  
        if (s.service === 'identity_keystone' && !s.app_credential_id && credentialsRequired) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.appCredentialId,
            field_key: s.service + '-' + s.region_name + '-app_credential_id',
          })
        }
  
        if (s.service === 'identity_keystone' && !appCredentialSecret && credentialsRequired) {
          errors_list.push({
            title: s.title + ' - ' + defaultTexts.appCredentialSecret,
            field_key: s.service + '-' + s.region_name + '-app_credential_secret',
          })
        }
      }
      
      if (s.enable_billing && hasBilling) {
        if (!s.resource_suspend_policy) {
          errors_list.push({
            title: defaultTexts.billingService + ' - ' + s.title + ' - ' + defaultTexts.suspendAction,
            field_key: s.service + '-' + s.region_name + '-resource_suspend_policy',
          })
        }

        if (!s.resource_suspend_period) {
          errors_list.push({
            title: defaultTexts.billingService + ' - ' + s.title + ' - ' + defaultTexts.suspendDelayMinutes,
            field_key: s.service + '-' + s.region_name + '-resource_suspend_period',
          })
        }

        if (!s.resource_delete_policy) {
          errors_list.push({
            title: defaultTexts.billingService + ' - ' + s.title + ' - ' + defaultTexts.finalAction,
            field_key: s.service + '-' + s.region_name + '-resource_delete_policy',
          })
        }

        if (!s.resource_delete_period) {
          errors_list.push({
            title: defaultTexts.billingService + ' - ' + s.title + ' - ' + defaultTexts.finalActionDelayMinutes,
            field_key: s.service + '-' + s.region_name + '-resource_delete_period',
          })
        }
      }
    }

    if (duplicated_region_name) {
      errors_list.push({
        title: defaultTexts.duplicatedRegionName,
      })
    }

    return errors_list
  }

  // ----------------------------------------------------------------------------------------------
  // Validate Admin UI ----------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------

  const validateAdminFrontendForm = () => {
    let errors_list = []

    adminUiDomain.forEach((item, index) => {
      const domain = item.subdomain_prefix ? item.subdomain_prefix + '.' + item.domain_name : item.domain_name

      if (!domain) {
        errors_list.push({
          title: defaultTexts.openStackAdminUi + ' - ' + defaultTexts.userInterfaceDomain,
          field_key: 'admin-domain_name-' + index,
        })
      } else if (!domainsWithCertififcates.includes(domain)) {
        errors_list.push({
          title: defaultTexts.noValidCertificateForDomain + ' - ' + domain,
        })
      }
    })

    if (!adminUiSiteKey) {
      errors_list.push({
        title: defaultTexts.openStackAdminUi + ' - ' + defaultTexts.siteKey,
        field_key: 'adminUiSiteKey',
      })
    }

    if (!adminUiSecretKey) {
      errors_list.push({
        title: defaultTexts.openStackAdminUi + ' - ' + defaultTexts.secretKey,
        field_key: 'adminUiSecretKey',
      })
    }

    if (adminUiLogo) {
      if (adminUiLogo.type && adminUiLogo.type !== 'image/png' && adminUiLogo.type !== 'image/jpeg') {
        errors_list.push({
          title: defaultTexts.openStackAdminUi + ' - ' + defaultTexts.uploadLogosFile,
        })
      }
    }

    return errors_list
  }

  // ----------------------------------------------------------------------------------------------
  // Validate Customer UI -------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  
  const validateCustomerFrontendForm = () => {
    let errors_list = []

    customerUiDomain.forEach((item, index) => {
      const domain = item.subdomain_prefix ? item.subdomain_prefix + '.' + item.domain_name : item.domain_name

      if (!domain) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.userInterfaceDomain,
          field_key: 'customer-domain_name-' + index,
        })
      } else if (!domainsWithCertififcates.includes(domain)) {
        errors_list.push({
          title: defaultTexts.noValidCertificateForDomain + ' - ' + domain,
        })
      }
    })

    if (!customerUiSiteKey) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.siteKey,
        field_key: 'customerUiSiteKey',
      })
    }

    if (!customerUiSecretKey) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.secretKey,
        field_key: 'customerUiSecretKey',
      })
    }

    if (customerUiLogo) {
      if (customerUiLogo.type && customerUiLogo.type !== 'image/png' && customerUiLogo.type !== 'image/jpeg') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.uploadLogosFile,
        })
      }
    }

    if (!defaultOpenStackDomain) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.defaultOpenStackDomain,
        field_key: 'defaultOpenStackDomain',
      })
    }

    if (!defaultOpenStackUserRole) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.defaultOpenStackUserRole,
        field_key: 'defaultOpenStackUserRole',
      })
    }

    if (isUsername && !usernamePriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.username + ' ' + defaultTexts.priority,
        field_key: 'usernamePriority',
      })
    }

    if (isPassword && !passwordPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.password + ' ' + defaultTexts.priority,
        field_key: 'passwordPriority',
      })
    }

    if (isConfirmPassword && !confirmPasswordPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.confirmPassword + ' ' + defaultTexts.priority,
        field_key: 'confirmPasswordPriority',
      })
    }

    if (isEmail && !emailPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.email + ' ' + defaultTexts.priority,
        field_key: 'emailPriority',
      })
    }

    if (isTermsOfUse && termsOfUseType === 'string' && !termsOfUseText) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        field_key: 'termsOfUseText',
      })
    }

    if (isTermsOfUse && termsOfUseType === 'file' && !termsOfUseFile) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
      })
    }

    if (isTermsOfUse && termsOfUseType === 'file' && termsOfUseFile) {
      if (termsOfUseFile.type && termsOfUseFile.type !== 'application/pdf') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        })
      }
    }

    if (isTermsOfUse && termsOfUseType === 'url' && !termsOfUseUrl) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        field_key: 'termsOfUseUrl',
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'string' && !privacyPolicyText) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        field_key: 'privacyPolicyText',
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'file' && !privacyPolicyFile) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'file' && privacyPolicyFile) {
      if (privacyPolicyFile.type && privacyPolicyFile.type !== 'application/pdf') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        })
      }
    }

    if (isPrivacyPolicy && privacyPolicyType === 'url' && !privacyPolicyUrl) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        field_key: 'privacyPolicyUrl',
      })
    }

    customFields.forEach((item, index) => {
      if (!item.field_key) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.fieldKey + ' ' + (index + 1),
          field_key: 'custom-fields-field_key-' + index,
        })
      }

      if (!item.label) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.label + ' ' + (index + 1),
          field_key: 'custom-fields-label-' + index,
        })
      }

      if (!item.priority) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.priority + ' ' + (index + 1),
          field_key: 'custom-fields-priority-' + index,
        })
      }
    })
    
    if (!backgroundType) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundType,
        field_key: 'backgroundType',
      })
    }

    if (backgroundType === 'color' && !colorType) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.colorType,
        field_key: 'colorType',
      })
    }

    if (backgroundType === 'color' && colorType === 'solid' && !backgroundColor) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundColor,
        field_key: 'backgroundColor',
      })
    }

    if (backgroundType === 'color' && colorType === 'gradient' && !gradientColor1) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.gradientColor + ' 1',
        field_key: 'gradientColor1',
      })
    }

    if (backgroundType === 'color' && colorType === 'gradient' && !gradientColor2) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.gradientColor + ' 2',
        field_key: 'gradientColor2',
      })
    }

    if (backgroundType === 'image' && !backgroundImage) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundImage,
        field_key: 'backgroundImage',
      })
    }

    if (backgroundType === 'image' && backgroundImage) {
      if (backgroundImage.type && backgroundImage.type !== 'image/png' && backgroundImage.type !== 'image/jpeg') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundImage,
          field_key: 'backgroundImage',
        })
      }
    }

    if (isContact && !contactCompany) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.company,
        field_key: 'contactCompany',
      })
    }

    if (isContact && contactPhone.length > 0 && !contactPhone[0]) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.phone,
        field_key: 'contactPhone',
      })
    }

    if (isContact && contactEmail.length > 0 && !contactEmail[0]) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.email,
        field_key: 'contactEmail',
      })
    }

    return errors_list
  }

  // ----------------------------------------------------------------------------------------------
  // Validate Billing General Config --------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------

  const validateBillingForm = () => {
    let errors_list = []

    if (!defaultAccountType) {
      errors_list.push({
        title: defaultTexts.billingService + ' - ' + defaultTexts.defaultAccountType,
        field_key: 'defaultAccountType',
      })
    }

    if (!postpaidInvoiceType) {
      errors_list.push({
        title: defaultTexts.billingService + ' - ' + defaultTexts.postpaidInvoiceType,
        field_key: 'postpaidInvoiceType',
      })
    }

    if (!postpaidInvoicePayPeriod) {
      errors_list.push({
        title: defaultTexts.billingService + ' - ' + defaultTexts.postpaidInvoicePayPeriod,
        field_key: 'postpaidInvoicePayPeriod',
      })
    }

    if (!currency) {
      errors_list.push({
        title: defaultTexts.billingService + ' - ' + defaultTexts.currency,
        field_key: 'currency',
      })
    }

    if (enableVat && !vatTax) {
      errors_list.push({
        title: defaultTexts.billingService + ' - ' + defaultTexts.vatTaxPerc,
        field_key: 'vatTax',
      })
    }

    paymentMethods.forEach(item => {
      if (item.name === 'paypal' && (!paymentMethodIds || !paymentMethodIds.paypal || !paymentMethodIds.paypal.idValue)) {
        errors_list.push({
          title: defaultTexts.billingService + ' - ' + defaultTexts.paypalClientId,
          field_key: 'paypalClientId',
        })
      }

      if (item.name === 'stripe' && (!paymentMethodIds || !paymentMethodIds.stripe || !paymentMethodIds.stripe.idValue)) {
        errors_list.push({
          title: defaultTexts.billingService + ' - ' + defaultTexts.stripeSecretKey,
          field_key: 'stripeSecretKey',
        })
      }
    })

    return errors_list
  }

  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // Validate Form --------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------

  const validateFormFields = (props) => {
    let errors_list = []

    const backend_form_errors = validateBackendForm()
    errors_list = [...errors_list, ...backend_form_errors]    

    if (showAdminUI) {
      const frontend_admin_form_errors = validateAdminFrontendForm()
      errors_list = [...errors_list, ...frontend_admin_form_errors]
    }

    if (showCustomerUI) {
      const frontend_customer_form_errors = validateCustomerFrontendForm()
      errors_list = [...errors_list, ...frontend_customer_form_errors]
    }

    if (showBillingService) {
      const billing_general_form_errors = validateBillingForm()
      errors_list = [...errors_list, ...billing_general_form_errors]
    }

    setErrors(errors_list)
    
    return errors_list.length === 0 ? true : false
  }

  const validateForm = async () => {
    const form_fields_valid = validateFormFields()
    let admin_domains_verified = { result: false, domains: adminUiDomain }
    let customer_domains_verified = { result: false, domains: customerUiDomain }

    const backend_domains_checked = await checkBackendDomains()

    if (form_fields_valid && showAdminUI) {
      admin_domains_verified = await verifyDomain({ type: 'admin' })  
    } else if (!showAdminUI) {
      admin_domains_verified = { result: true, domains: [] }
    }

    if (form_fields_valid && showCustomerUI) {
      customer_domains_verified = await verifyDomain({ type: 'client' })      
    } else if (!showCustomerUI) {
      customer_domains_verified = { result: true, domains: [] }
    }

    if (form_fields_valid && !backend_domains_checked.result) {
      let errors_list = []

      backend_domains_checked.backend_services.forEach(item => {
        if (item.access !== 'checked') {
          errors_list.push({
            title: item.title + ' - ' + defaultTexts.accessDenied,
          })
        }
      })

      setErrors(prev => [...prev, ...errors_list])      
    }
 
    if (form_fields_valid && !admin_domains_verified.result) {
      setErrors(prev => [...prev, { title: defaultTexts.adminUiDomain + ' ' + defaultTexts.notVerified }])
    }

    if (form_fields_valid && !customer_domains_verified.result) {
      setErrors(prev => [...prev, { title: defaultTexts.customerUiDomain + ' ' + defaultTexts.notVerified }])
    }

    const result = (form_fields_valid && backend_domains_checked.result && admin_domains_verified.result && customer_domains_verified.result)

    return {
      result,
      backend_services: backend_domains_checked.backend_services,
      admin_ui_domains: admin_domains_verified.domains,
      customer_ui_domains: customer_domains_verified.domains,
    }
  }

  const handleClickPrev = () => {
    setStep(2)
    dispatch(setProgressStep({ progress_step: 2 }))
  }

  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // Save Data ------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------
  // ----------------------------------------------------------------------------------------------

  const handleClickNext = async () => {
    setIsLoading(true)
    setSubmitted(true)

    const form_valid = await validateForm()    
    
    if (form_valid.result) {
      const adminUiUserData = {
        service_domain: form_valid.admin_ui_domains,
        certificate_generate: adminUiCertificateGenerate,
        certificates: adminUiCertficates,
        primary_color: adminUiPrimaryColor,
        secondary_color: adminUiSecondaryColor,
        logo: adminUiLogo,
        captcha_config: {
          site_key: adminUiSiteKey,
          secret_key: adminUiSecretKey,
        },
      }

      let promo_text = []
      let form_fields = []
      let documents = []
      let priority_values = []

      if (promoText1) {
        promo_text.push(promoText1)
      }

      if (promoText2) {
        promo_text.push(promoText2)
      }

      if (promoText3) {
        promo_text.push(promoText3)
      }

      if (isUsername) {
        form_fields.push({
          priority: usernamePriority,
          field_key: 'username',
          openstack_field: 'name',
          label: 'Username',
          field_type: 'string',
          required: true,
          content_type: null,
        })
        priority_values.push(usernamePriority)
      }

      if (isPassword) {
        form_fields.push({
          priority: passwordPriority,
          field_key: 'password',
          openstack_field: 'password',
          label: 'Password',
          field_type: 'string',
          required: true,
          content_type: 'password',
        })
        priority_values.push(passwordPriority)
      }

      if (isConfirmPassword) {
        form_fields.push({
          priority: confirmPasswordPriority,
          field_key: 'confirm_password',
          openstack_field: null,
          label: 'Confirm password',
          field_type: 'string',
          required: true,
          content_type: 'password',
        })
        priority_values.push(confirmPasswordPriority)
      }

      if (isEmail) {
        form_fields.push({
          priority: emailPriority,
          field_key: 'email',
          openstack_field: 'email',
          label: 'E-mail',
          field_type: 'string',
          required: true,
          content_type: 'email',
        })
        priority_values.push(emailPriority)
      }

      customFields.forEach(item => {
        form_fields.push({
          priority: item.priority,
          field_key: item.field_key,
          openstack_field: item.field_key,
          label: item.label,
          field_type: 'string',
          required: item.required,
          content_type: null,
        })
        priority_values.push(item.priority)
      })

      const maxPriortiy = Math.max(...priority_values)

      if (isTermsOfUse) {
        form_fields.push({
          priority: maxPriortiy + 10,
          field_key: 'tou',
          openstack_field: 'tou',
          label: 'Terms of Use',
          field_type: 'boolean',
          required: true,
          content_type: null,
        })

        const terms_of_use_file = termsOfUseType === 'file' ? termsOfUseFile : termsOfUseUrlPrefix + termsOfUseUrl

        documents.push({
          label: 'Terms of Use',
          type: termsOfUseType,
          value: termsOfUseType === 'string' ? termsOfUseText : terms_of_use_file,
        })
      }

      if (isPrivacyPolicy) {
        form_fields.push({
          priority: maxPriortiy + 20,
          field_key: 'pp',
          openstack_field: 'pp',
          label: 'Privacy Policy',
          field_type: 'boolean',
          required: true,
          content_type: null,
        })

        const privacy_policy_file = privacyPolicyType === 'file' ? privacyPolicyFile : privacyPolicyUrlPrefix + privacyPolicyUrl

        documents.push({
          label: 'Privacy Policy',
          type: privacyPolicyType,
          value: privacyPolicyType === 'string' ? privacyPolicyText : privacy_policy_file,
        })
      }

      const customerUiUserData = {
        service_domain: form_valid.customer_ui_domains,
        certificate_generate: customerUiCertificateGenerate,
        certificates: customerUiCertficates,
        primary_color: customerUiPrimaryColor,
        secondary_color: customerUiSecondaryColor,
        logo: customerUiLogo,
        openstack_domain: defaultOpenStackDomain,
        openstack_role: defaultOpenStackUserRole,
        contact_us: isContact ? {
          phone: contactPhone,
          email: contactEmail,
          company: contactCompany,
        } : null,
        promo_config: {
          background_type: backgroundType,
          background_color_type: colorType,
          background_color: backgroundColor,
          gradient_color_1: gradientColor1,
          gradient_color_2: gradientColor2,
          background_image: backgroundImage,
          heading: headingText,
          promo_text,
        },
        captcha_config: {
          site_key: customerUiSiteKey,
          secret_key: customerUiSecretKey,
        },
        signup_config: {
          enabled: signUpEnabled,
          form_fields,
          documents,
        },
      }

      const billingUserData = {
        currency,
        payment_methods: paymentMethods,
        status: enableBillingService ? 'active' : 'inactive',
        default_billing_type: defaultAccountType,
        postpaid_invoice: postpaidInvoiceType,
        postpaid_invoice_pay_period: postpaidInvoicePayPeriod,
        use_vat_tax: enableVat,
        price_includes_vat: pricesIncludeVat,
        vat: vatTax,
        allow_public_price_calculator: allowPublicCalculator,
      }

      setStep(4)
      dispatch(setOpenStackConfigs({ openstack_configs: form_valid.backend_services }))
      dispatch(setAdminUiConfigs({ admin_ui_configs: adminUiUserData }))
      dispatch(setCustomerUiConfigs({ customer_ui_configs: customerUiUserData }))
      dispatch(setBillingConfigs({ billing_configs: billingUserData }))
      dispatch(setBillingConfigPermissions({ billing_permissions: billingPermissions }))
    } else {
      handleErrorDialogOpen()
    }

    setIsLoading(false)
  }

  const getSelectFieldList = useCallback((service, field, sub_field) => {
    let result = []
    let options_list = []

    const service_object = supportedServiceConfigs.find(item => item.service === service)

    if (sub_field && service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field][sub_field] && service_object.config_params[field][sub_field].length > 0) {
      options_list = service_object.config_params[field][sub_field]
    } else if (service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field].length > 0) {
      options_list = service_object.config_params[field]
    }

    options_list.forEach(item => {
      result.push({
        keyword: capitalizeFirstLetter(item),
        value: item,
      })
    })

    return result
  }, [supportedServiceConfigs])
  
  const getRegionConfig = useCallback((service, title, number, isDefault) => {
    return {
      is_default: isDefault ? true : false,
      title,
      service_domain: '',
      api_version: '',
      api_version_list: getSelectFieldList(service, 'api_version'),
      is_identity_provider: service === 'identity_keystone' ? true : false,
      default_region: (isDefault && service === 'identity_keystone') ? 'Region-1' : '',
      region_name: 'Region-' + number,
      app_credential_id: '',
      app_credential_secret: '',
      visible_to_service: ['custom_admin_ui', 'custom_client_ui'],
      resource_suspend_period: '',
      resource_delete_period: '',
      resource_suspend_policy: '',
      resource_delete_policy: '',
      access: '',
      enable_billing: showBillingService ? isBillingAvailable(service, supportedServiceConfigs) : false,
    }
  }, [getSelectFieldList, showBillingService, supportedServiceConfigs])

  useEffect(() => {
    const custom_admin_ui = selectedServices.find(item => item.service_type === 'frontend' && item.service === 'custom_admin_ui')
    setShowAdminUi(custom_admin_ui ? true : false)

    const custom_client_ui = selectedServices.find(item => item.service_type === 'frontend' && item.service === 'custom_client_ui')
    setShowCustomerUi(custom_client_ui ? true : false)
    
    const openstack_service = selectedServices.find(item => item.service_type === 'backend')
    const backup_service = selectedServices.find(item => item.service_type === 'backup')
    const ui_service = custom_admin_ui || custom_client_ui
    setShowOpenStackServices( ((openstack_service && ui_service) || backup_service) ? true : false )

    const billing_service = selectedServices.find(item => item.service_type === 'billing')
    setShowBillingService(billing_service ? true : false)

    setBillingServicesConfigurable( ((openstack_service && ui_service) || backup_service) ? false : true )
  }, [selectedServices])

  useEffect(() => {
    let config_menu = getConfigMenu()

    if (!showOpenStackServices) {
      config_menu = config_menu.filter(item => item.value !== 'openstack_services')
    }

    if (!showAdminUI && !showCustomerUI) {
      config_menu = config_menu.filter(item => item.value !== 'user_interfaces')
    }

    if (!showBillingService) {
      config_menu = config_menu.filter(item => item.value !== 'billing_service')
    }

    setConfigMenu(config_menu)
  }, [showOpenStackServices, showAdminUI, showCustomerUI, showBillingService, getConfigMenu])

  useEffect(() => {
    if (configMenu.length > 0) {
      setSelectedTab(configMenu[0].value)
    } else {
      setSelectedTab(null)
    }    
  }, [configMenu])

  useEffect(() => {
    setSelectedBackendServices(selectedServices.filter(item => item.service_type === 'backend'))
  }, [selectedServices])

  // -----------------------------------------------------------------------------------------------
  // Get Backend Config ----------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------
  
  useEffect(() => {
    if (openstack_configs.length > 0) {
      setBackendUserData(openstack_configs)
    } else {
      let backend_user_data = []

      selectedBackendServices.forEach(item => {
        backend_user_data.push({
          service: item.service,
          ...getRegionConfig(item.service, item.title.value, 1, true),
        })
      })

      setBackendUserData(backend_user_data)
    }    
  }, [openstack_configs, selectedBackendServices, getRegionConfig])

  useEffect(() => {
    const service_object = backendUserData.find(item => item.is_identity_provider === true)
    setBackendIsIdentityProviderSelected(service_object ? true : false)
  }, [backendUserData])

  // -----------------------------------------------------------------------------------------------
  // Get Admin UI Config ---------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------

  useEffect(() => {
    if (admin_ui_configs && admin_ui_configs.service_domain && admin_ui_configs.service_domain.length > 0) {
      setAdminUiDomain(admin_ui_configs.service_domain)
    } else {
      setAdminUiDomain([{ ...uiDomainInitial }])
    }

    if (admin_ui_configs) {
      setAdminUiCertificateGenerate(admin_ui_configs.certificate_generate ? true : false)
    } else {
      setAdminUiCertificateGenerate(true)
    }

    if (admin_ui_configs && admin_ui_configs.certificates) {
      setAdminUiCertificates(admin_ui_configs.certificates)
    } else {
      setAdminUiCertificates([{ ...uiCertificateInitial }])
    }

    if (admin_ui_configs && admin_ui_configs.primary_color) {
      setAdminUiPrimaryColor(admin_ui_configs.primary_color)
    } else {
      setAdminUiPrimaryColor(theme.palette.oriolesOrange)
    }

    if (admin_ui_configs && admin_ui_configs.secondary_color) {
      setAdminUiSecondaryColor(admin_ui_configs.secondary_color)
    } else {
      setAdminUiSecondaryColor(theme.palette.mayGreen)
    }

    if (admin_ui_configs && admin_ui_configs.captcha_config && admin_ui_configs.captcha_config.site_key) {
      setAdminUiSiteKey(admin_ui_configs.captcha_config.site_key)
    } else {
      setAdminUiSiteKey('')
    }

    if (admin_ui_configs && admin_ui_configs.captcha_config && admin_ui_configs.captcha_config.secret_key) {
      setAdminUiSecretKey(admin_ui_configs.captcha_config.secret_key)
    } else {
      setAdminUiSecretKey('')
    }
  }, [admin_ui_configs, theme])

  // -----------------------------------------------------------------------------------------------
  // Get Customer UI Config ------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------

  useEffect(() => {
    if (customer_ui_configs && customer_ui_configs.service_domain && customer_ui_configs.service_domain.length > 0) {
      setCustomerUiDomain(customer_ui_configs.service_domain)
    } else {
      setCustomerUiDomain([{ ...uiDomainInitial }])
    }

    if (customer_ui_configs) {
      setCustomerUiCertificateGenerate(customer_ui_configs.certificate_generate ? true : false)
    } else {
      setCustomerUiCertificateGenerate(true)
    }

    if (customer_ui_configs && customer_ui_configs.certificates) {
      setCustomerUiCertificates(customer_ui_configs.certificates)
    } else {
      setCustomerUiCertificates([{ ...uiCertificateInitial }])
    }

    if (customer_ui_configs && customer_ui_configs.primary_color) {
      setCustomerUiPrimaryColor(customer_ui_configs.primary_color)
    } else {
      setCustomerUiPrimaryColor(theme.palette.brilliantAzure)
    }

    if (customer_ui_configs && customer_ui_configs.secondary_color) {
      setCustomerUiSecondaryColor(customer_ui_configs.secondary_color)
    } else {
      setCustomerUiSecondaryColor(theme.palette.darkCyan)
    }

    if (customer_ui_configs && customer_ui_configs.captcha_config && customer_ui_configs.captcha_config.site_key) {
      setCustomerUiSiteKey(customer_ui_configs.captcha_config.site_key)
    } else {
      setCustomerUiSiteKey('')
    }

    if (customer_ui_configs && customer_ui_configs.captcha_config && customer_ui_configs.captcha_config.secret_key) {
      setCustomerUiSecretKey(customer_ui_configs.captcha_config.secret_key)
    } else {
      setCustomerUiSecretKey('')
    }

    if (customer_ui_configs && customer_ui_configs.openstack_domain) {
      setDefaultOpenStackDomain(customer_ui_configs.openstack_domain)
    } else {
      setDefaultOpenStackDomain('')
    }

    if (customer_ui_configs && customer_ui_configs.openstack_role) {
      setDefaultOpenStackUserRole(customer_ui_configs.openstack_role)
    } else {
      setDefaultOpenStackUserRole('')
    }

    if (customer_ui_configs && customer_ui_configs.signup_config) {
      setSignUpEnabled(customer_ui_configs.signup_config.enabled ? true : false)
    } else {
      setSignUpEnabled(true)
    }

    if (customer_ui_configs && customer_ui_configs.contact_us) {
      setIsContact(true)
    } else {
      setIsContact(false)
    }

    if (customer_ui_configs && customer_ui_configs.contact_us && customer_ui_configs.contact_us.phone) {
      setContactPhone(customer_ui_configs.contact_us.phone)
    } else {
      setContactPhone([''])
    }

    if (customer_ui_configs && customer_ui_configs.contact_us && customer_ui_configs.contact_us.email) {
      setContactEmail(customer_ui_configs.contact_us.email)
    } else {
      setContactEmail([''])
    }

    if (customer_ui_configs && customer_ui_configs.contact_us && customer_ui_configs.contact_us.company) {
      setContactCompany(customer_ui_configs.contact_us.company)
    } else {
      setContactCompany('')
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.background_type) {
      setBackgroundType(customer_ui_configs.promo_config.background_type)
    } else {
      setBackgroundType('')
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.background_color_type) {
      setColorType(customer_ui_configs.promo_config.background_color_type)
    } else {
      setColorType('')
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.background_color) {
      setBackgroundColor(customer_ui_configs.promo_config.background_color)
    } else {
      setBackgroundColor(theme.palette.darkCyan)
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.gradient_color_1) {
      setGradientColor1(customer_ui_configs.promo_config.gradient_color_1)
    } else {
      setGradientColor1(theme.palette.darkCyan)
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.gradient_color_2) {
      setGradientColor2(customer_ui_configs.promo_config.gradient_color_2)
    } else {
      setGradientColor2(theme.palette.darkCyan)
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.heading) {
      setHeadingText(customer_ui_configs.promo_config.heading)
    } else {
      setHeadingText('')
    }

    if (customer_ui_configs && customer_ui_configs.promo_config && customer_ui_configs.promo_config.promo_text) {
      if (customer_ui_configs.promo_config.promo_text.length > 0) {
        setPromoText1(customer_ui_configs.promo_config.promo_text[0])
      } else {
        setPromoText1('')
      }

      if (customer_ui_configs.promo_config.promo_text.length > 1) {
        setPromoText2(customer_ui_configs.promo_config.promo_text[1])
      } else {
        setPromoText2('')
      }

      if (customer_ui_configs.promo_config.promo_text.length > 2) {
        setPromoText3(customer_ui_configs.promo_config.promo_text[2])
      } else {
        setPromoText3('')
      }
    } else {
      setPromoText1('')
      setPromoText2('')
      setPromoText3('')
    }

    if (customer_ui_configs && customer_ui_configs.signup_config && customer_ui_configs.signup_config.form_fields && customer_ui_configs.signup_config.form_fields.length > 0) {
      let custom_fields = []

      customer_ui_configs.signup_config.form_fields.forEach(item => {
        if (item.field_key === 'username') {
          setIsUsername(true)
          setUsernamePriority(item.priority)
        } else if (item.field_key === 'password') {
          setIsPassword(true)
          setPasswordPriority(item.priority)
        } else if (item.field_key === 'confirm_password') {
          setIsConfirmPassword(true)
          setConfirmPasswordPriority(item.priority)
        } else if (item.field_key === 'email') {
          setIsEmail(true)
          setEmailPriority(item.priority)
        } else {
          custom_fields.push({
            field_key: item.field_key,
            label: item.label,
            priority: item.priority,
            required: item.required,
          })
        }
      })

      setCustomFields(custom_fields)
    } else {
      setIsUsername(true)
      setUsernamePriority(10)
      setIsPassword(true)
      setPasswordPriority(20)
      setIsConfirmPassword(true)
      setConfirmPasswordPriority(30)
      setIsEmail(true)
      setEmailPriority(40)
      setCustomFields([])
    }

    if (customer_ui_configs && customer_ui_configs.signup_config && customer_ui_configs.signup_config.documents && customer_ui_configs.signup_config.documents.length > 0) {
      customer_ui_configs.signup_config.documents.forEach(item => {
        if (item.label === 'Terms of Use') {
          setIsTermsOfUse(true)
          setTermsOfUseText(item.type === 'string' ? item.value : '')

          let url_prefix = 'https://'
          let url_cut = ''

          if (item.type === 'url') {
            let url_list = item.value.split('//')
            if (url_list.length > 1) {
              url_prefix = url_list[0] + '//'
              url_cut = url_list[1]
            }
          }
          
          setTermsOfUseType(item.type)
          setTermsOfUseUrlPrefix(url_prefix)
          setTermsOfUseUrl(url_cut)
        }

        if (item.label === 'Privacy Policy') {
          setIsPrivacyPolicy(true)
          setPrivacyPolicyText(item.type === 'string' ? item.value : '')

          let url_prefix = 'https://'
          let url_cut = ''

          if (item.type === 'url') {
            let url_list = item.value.split('//')
            if (url_list.length > 1) {
              url_prefix = url_list[0] + '//'
              url_cut = url_list[1]
            }
          }
          
          setPrivacyPolicyType(item.type)
          setPrivacyPolicyUrlPrefix(url_prefix)
          setPrivacyPolicyUrl(url_cut)
        }
      })
    } else {
      setIsTermsOfUse(false)
      setTermsOfUseText('')
      setTermsOfUseUrlPrefix('https://')
      setTermsOfUseUrl('')
      setTermsOfUseType('string')
      setIsPrivacyPolicy(false)
      setPrivacyPolicyText('')
      setPrivacyPolicyUrlPrefix('https://')
      setPrivacyPolicyUrl('')
      setPrivacyPolicyType('string')
    }
  }, [customer_ui_configs, theme])

  // -----------------------------------------------------------------------------------------------
  // Get Billing General Config --------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------

  useEffect(() => {
    if (billing_configs && billing_configs.currency) {
      setCurrency(billing_configs.currency)
    } else {
      setCurrency('')
    }
    
    if (billing_configs && billing_configs.payment_methods) {
      setPaymentMethods(billing_configs.payment_methods)
    } else {
      setPaymentMethods([])
    }

    if (billing_configs && billing_configs.status) {
      setEnableBillingService(billing_configs.status === 'active' ? true : false)
    } else {
      setEnableBillingService(false)
    }

    if (billing_configs && billing_configs.default_billing_type) {
      setDefaultAccountType(billing_configs.default_billing_type)
    } else {
      setDefaultAccountType('')
    }

    if (billing_configs && billing_configs.postpaid_invoice) {
      setPostpaidInvoiceType(billing_configs.postpaid_invoice)
    } else {
      setPostpaidInvoiceType('')
    }

    if (billing_configs && billing_configs.postpaid_invoice_pay_period) {
      setPostpaidInvoicePayPeriod(billing_configs.postpaid_invoice_pay_period)
    } else {
      setPostpaidInvoicePayPeriod('')
    }

    if (billing_configs) {
      setEnableVat(billing_configs.use_vat_tax ? true : false)
    } else {
      setEnableVat(true)
    }

    if (billing_configs) {
      setPricesIncludeVat(billing_configs.price_includes_vat ? true : false)
    } else {
      setPricesIncludeVat(true)
    }

    if (billing_configs && billing_configs.vat) {
      setVatTax(billing_configs.vat)
    } else {
      setVatTax('')
    }

    if (billing_configs) {
      setAllowPublicCalculator(billing_configs.allow_public_price_calculator ? true : false)
    } else {
      setAllowPublicCalculator(true)
    }
  }, [billing_configs])

  // -----------------------------------------------------------------------------------------------
  // Get Billing Permissions -----------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------

  const getDefaultBillingPermissions = useCallback(() => {
    return {
      visible_to_service: ['custom_admin_ui', 'custom_client_ui'],
      custom_admin_ui: [
        {
          section: 'billing_configs',
          permissions: ['read'],
        },
        {
          section: 'billing_services',
          permissions: ['read', 'create', 'update', 'delete'],
        },
        {
          section: 'billing_deposits',
          permissions: ['read', 'update'],
        },
        {
          section: 'billing_prices',
          permissions: ['read', 'create', 'update'],
        },
        {
          section: 'billing_analytics',
          permissions: ['read'],
        },
      ]
    }
  }, [])

  useEffect(() => {
    if (billing_permissions) {
      setBillingPermissions(billing_permissions)
    } else {
      setBillingPermissions(getDefaultBillingPermissions)
    }
  }, [billing_permissions, getDefaultBillingPermissions])


  // -----------------------------------------------------------------------------------------------
  // Check If All Domains Have Certificates --------------------------------------------------------
  // -----------------------------------------------------------------------------------------------

  useEffect(() => {
    let domains_with_certificates = []

    adminUiDomain.forEach(d => {
      let domain_name = ''

      if (d.domain_name) {
        domain_name = d.subdomain_prefix ? d.subdomain_prefix + '.' + d.domain_name : d.domain_name
      }

      if (adminUiCertificateGenerate) {
        domains_with_certificates.push(domain_name)
      } else if (domain_name) {
        adminUiCertficates.forEach(c => {
          if (c.domain) {
            const is_wildcard_match = isWildcardMatch(c.domain, domain_name)
            if (is_wildcard_match) {
              domains_with_certificates.push(domain_name)
            }
          }
        })
      }
    })

    customerUiDomain.forEach(d => {
      let domain_name = ''

      if (d.domain_name) {
        domain_name = d.subdomain_prefix ? d.subdomain_prefix + '.' + d.domain_name : d.domain_name
      }

      if (customerUiCertificateGenerate) {
        domains_with_certificates.push(domain_name)
      } else if (domain_name) {
        customerUiCertficates.forEach(c => {
          if (c.domain) {
            const is_wildcard_match = isWildcardMatch(c.domain, domain_name)
            if (is_wildcard_match) {
              domains_with_certificates.push(domain_name)
            }
          }
        })
      }
    })

    setDomainsWithCertificates(domains_with_certificates)
  }, [
    adminUiDomain,
    adminUiCertficates,
    adminUiCertificateGenerate,
    customerUiDomain,
    customerUiCertficates,
    customerUiCertificateGenerate,
  ])
  
  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <ConfigMenu
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        configMenu={configMenu}
      />

      {
        (selectedTab === 'openstack_services' && showOpenStackServices) &&
        <ConfigOpenStack
          selectedBackendServices={selectedBackendServices}
          backendUserData={backendUserData}
          setBackendUserData={setBackendUserData}
          getRegionConfig={getRegionConfig}
          backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
          errors={errors}
          setErrors={setErrors}
          submitted={submitted}
          validateFormFields={validateFormFields}
          appCredentialSecret={appCredentialSecret}
          setAppCredentialSecret={setAppCredentialSecret}
        />
      }

      {
        (selectedTab === 'user_interfaces' && (showAdminUI || showCustomerUI)) &&
        <ConfigUserInterfaces 
          showAdminUI={showAdminUI}
          showCustomerUI={showCustomerUI}
          adminUiDomain={adminUiDomain}
          setAdminUiDomain={setAdminUiDomain}
          adminUiCertificateGenerate={adminUiCertificateGenerate}
          setAdminUiCertificateGenerate={setAdminUiCertificateGenerate}
          adminUiCertficates={adminUiCertficates}
          setAdminUiCertificates={setAdminUiCertificates}
          adminUiSiteKey={adminUiSiteKey}
          setAdminUiSiteKey={setAdminUiSiteKey}
          adminUiSecretKey={adminUiSecretKey}
          setAdminUiSecretKey={setAdminUiSecretKey}
          adminUiLogo={adminUiLogo}
          setAdminUiLogo={setAdminUiLogo}
          adminUiPrimaryColor={adminUiPrimaryColor}
          setAdminUiPrimaryColor={setAdminUiPrimaryColor}
          adminUiSecondaryColor={adminUiSecondaryColor}
          setAdminUiSecondaryColor={setAdminUiSecondaryColor}
          customerUiDomain={customerUiDomain}
          setCustomerUiDomain={setCustomerUiDomain}
          customerUiCertificateGenerate={customerUiCertificateGenerate}
          setCustomerUiCertificateGenerate={setCustomerUiCertificateGenerate}
          customerUiCertficates={customerUiCertficates}
          setCustomerUiCertificates={setCustomerUiCertificates}
          customerUiSiteKey={customerUiSiteKey}
          setCustomerUiSiteKey={setCustomerUiSiteKey}
          customerUiSecretKey={customerUiSecretKey}
          setCustomerUiSecretKey={setCustomerUiSecretKey}
          customerUiLogo={customerUiLogo}
          setCustomerUiLogo={setCustomerUiLogo}
          customerUiPrimaryColor={customerUiPrimaryColor}
          setCustomerUiPrimaryColor={setCustomerUiPrimaryColor}
          customerUiSecondaryColor={customerUiSecondaryColor}
          setCustomerUiSecondaryColor={setCustomerUiSecondaryColor}
          defaultOpenStackDomain={defaultOpenStackDomain}
          setDefaultOpenStackDomain={setDefaultOpenStackDomain}
          defaultOpenStackUserRole={defaultOpenStackUserRole}
          setDefaultOpenStackUserRole={setDefaultOpenStackUserRole}
          signUpEnabled={signUpEnabled}
          setSignUpEnabled={setSignUpEnabled}
          isUsername={isUsername}
          setIsUsername={setIsUsername}
          usernamePriority={usernamePriority}
          setUsernamePriority={setUsernamePriority}
          isPassword={isPassword}
          setIsPassword={setIsPassword}
          passwordPriority={passwordPriority}
          setPasswordPriority={setPasswordPriority}
          isConfirmPassword={isConfirmPassword}
          setIsConfirmPassword={setIsConfirmPassword}
          confirmPasswordPriority={confirmPasswordPriority}
          setConfirmPasswordPriority={setConfirmPasswordPriority}
          isEmail={isEmail}
          setIsEmail={setIsEmail}
          emailPriority={emailPriority}
          setEmailPriority={setEmailPriority}
          isTermsOfUse={isTermsOfUse}
          setIsTermsOfUse={setIsTermsOfUse}
          termsOfUseText={termsOfUseText}
          setTermsOfUseText={setTermsOfUseText}
          termsOfUseFile={termsOfUseFile}
          setTermsOfUseFile={setTermsOfUseFile}
          termsOfUseUrlPrefix={termsOfUseUrlPrefix}
          setTermsOfUseUrlPrefix={setTermsOfUseUrlPrefix}
          termsOfUseUrl={termsOfUseUrl}
          setTermsOfUseUrl={setTermsOfUseUrl}
          termsOfUseType={termsOfUseType}
          setTermsOfUseType={setTermsOfUseType}
          isPrivacyPolicy={isPrivacyPolicy}
          setIsPrivacyPolicy={setIsPrivacyPolicy}
          privacyPolicyText={privacyPolicyText}
          setPrivacyPolicyText={setPrivacyPolicyText}
          privacyPolicyFile={privacyPolicyFile}
          setPrivacyPolicyFile={setPrivacyPolicyFile}
          privacyPolicyUrlPrefix={privacyPolicyUrlPrefix}
          setPrivacyPolicyUrlPrefix={setPrivacyPolicyUrlPrefix}
          privacyPolicyUrl={privacyPolicyUrl}
          setPrivacyPolicyUrl={setPrivacyPolicyUrl}
          privacyPolicyType={privacyPolicyType}
          setPrivacyPolicyType={setPrivacyPolicyType}
          customFields={customFields}
          setCustomFields={setCustomFields}
          backgroundType={backgroundType}
          setBackgroundType={setBackgroundType}
          colorType={colorType}
          setColorType={setColorType}
          backgroundColor={backgroundColor}
          setBackgroundColor={setBackgroundColor}
          gradientColor1={gradientColor1}
          setGradientColor1={setGradientColor1}
          gradientColor2={gradientColor2}
          setGradientColor2={setGradientColor2}
          backgroundImage={backgroundImage}
          setBackgroundImage={setBackgroundImage}
          headingText={headingText}
          setHeadingText={setHeadingText}
          promoText1={promoText1}
          setPromoText1={setPromoText1}
          promoText2={promoText2}
          setPromoText2={setPromoText2}
          promoText3={promoText3}
          setPromoText3={setPromoText3}
          isContact={isContact}
          setIsContact={setIsContact}
          contactCompany={contactCompany}
          setContactCompany={setContactCompany}
          contactPhone={contactPhone}
          setContactPhone={setContactPhone}
          contactEmail={contactEmail}
          setContactEmail={setContactEmail}
          domainsWithCertififcates={domainsWithCertififcates}
          backgroundTypeList={getSelectFieldList('custom_client_ui', 'promo_config', 'background_type')}
          colorTypeList={getSelectFieldList('custom_client_ui', 'promo_config', 'background_color_type')}
          verifyDomain={verifyDomain}
          errors={errors}
          setErrors={setErrors}
          submitted={submitted}
          validateFormFields={validateFormFields}
        />
      }

      {
        (selectedTab === 'billing_service' && showBillingService) &&
        <ConfigBilling
          supportedServiceConfigs={supportedServiceConfigs}
          supportedPaymentMethods={supportedPaymentMethods}
          enableBillingService={enableBillingService}
          setEnableBillingService={setEnableBillingService}
          defaultAccountType={defaultAccountType}
          setDefaultAccountType={setDefaultAccountType}
          postpaidInvoiceType={postpaidInvoiceType}
          setPostpaidInvoiceType={setPostpaidInvoiceType}
          postpaidInvoicePayPeriod={postpaidInvoicePayPeriod}
          setPostpaidInvoicePayPeriod={setPostpaidInvoicePayPeriod}
          allowPublicCalculator={allowPublicCalculator}
          setAllowPublicCalculator={setAllowPublicCalculator}
          currency={currency}
          setCurrency={setCurrency}
          enableVat={enableVat}
          setEnableVat={setEnableVat}
          pricesIncludeVat={pricesIncludeVat}
          setPricesIncludeVat={setPricesIncludeVat}
          vatTax={vatTax}
          setVatTax={setVatTax}
          paymentMethods={paymentMethods}
          setPaymentMethods={setPaymentMethods}
          selectedBackendServices={selectedBackendServices}
          backendUserData={backendUserData}
          setBackendUserData={setBackendUserData}
          getRegionConfig={getRegionConfig}
          backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
          billingServicesConfigurable={billingServicesConfigurable}
          billingPermissions={billingPermissions}
          setBillingPermissions={setBillingPermissions}
          getDefaultBillingPermissions={getDefaultBillingPermissions}
          errors={errors}
          setErrors={setErrors}
          submitted={submitted}
          validateFormFields={validateFormFields}
          appCredentialSecret={appCredentialSecret}
          setAppCredentialSecret={setAppCredentialSecret}
          paymentMethodIds={paymentMethodIds}
          setPaymentMethodIds={setPaymentMethodIds}
        />
      }

      <Stack
        direction='row'
        justifyContent='space-between'
      >
        <Button
          variant='text'
          disableRipple
          disableElevation
          sx={nextButtonStyle}
          onClick={handleClickPrev}
        >
          {defaultTexts.back}
        </Button>
        <Button
          variant='text'
          disableRipple
          disableElevation
          sx={nextButtonStyle}
          onClick={handleClickNext}
        >
          {defaultTexts.next}
        </Button>
      </Stack>

      <CustomDialog
        open={errorDialogOpen}
        onClose={handleErrorDialogClose}
        dialogTitle={{ title: defaultTexts.formValidationError }}
        dialogBody={{
          text: defaultTexts.formValidationErrorText,
          sx: { paddingBottom: '20px' }
        }}
      >
        {
          errors.map((item, index) => (
            <Box key={index}>{item.title}</Box>
          ))
        }
      </CustomDialog>
    </>
  )
}

export default ConfigWrapper